import { createApp, h } from 'vue'
import { app, plugin, Link } from '@inertiajs/inertia-vue3'
import { InertiaProgress as progress } from '@inertiajs/progress'
import Layout from './Shared/Layout.vue'
//import 'tw-elements'
const el = document.getElementById('app')

progress.init()
/*
createApp({
  render: () => h(app, {
    initialPage: JSON.parse(el.dataset.page),
    resolveComponent: name => import(`./Pages/${name}`).then(m => m.default),
  })
})*/
createApp({
    render: () => h(app, {
        initialPage: JSON.parse(el.dataset.page),
        resolveComponent: async name => {
            const page = (await import(`./Pages/${name}`)).default
            if (name !== 'Auth/Login') {
                page.layout ??= Layout
            }
            return page
          }
        })
    })
.mixin({
    computed: {
        modalComponent() {
            console.log('mixin is adding props ...')
            console.log(this.$page.props.modal)
          return this.$page.props.modal
            ? this.$page.props.modal //'modal-dialog'//() => import(`./Pages/${this.$page.props.modal}`)
            : false
        }
      },
    methods: {
    route: window.route,
    title: title => `Fleet - ${title}`,
}})
.use(plugin)
.component('InertiaLink', Link)
.mount(el)
